import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import Button from 'app/common/ui/Button';
import PlainInput from 'app/common/ui/PlainInput';

import { popup } from 'app/common/actions/popup';
import { sendNewPoll } from '../../../../actions/fund/polls';
import { beginEditPoll, stopEditPoll, updatePoll } from '../../../../actions/fund/poll';
import PlainTextArea from '../../../_ui/PlainTextArea';
import PlainDateInput from '../PlainDateInput';
import styles from './PollEdit.scss';
import config from '../../../../config';
import IconLoaderClock from '../../../_Icons/IconLoaderClock';

// const propTypes = {
//   params: React.PropTypes.shape({
//     schoolId: React.PropTypes.string,
//     pollId: React.PropTypes.string,
//     type: React.PropTypes.string,
//   }).isRequired,
//   actions: React.PropTypes.shape({
//     sendNewPoll: React.PropTypes.func.isRequired,
//     popup: React.PropTypes.func.isRequired,
//   }),
//   polls: React.PropTypes.shape({
//     isSending: React.PropTypes.bool,
//   }).isRequired,
//   location: React.PropTypes.shape({
//     pathname: React.PropTypes.string.isRequired,
//   }),
//   poll: React.PropTypes.object.isRequired,
// };

const defaultProps = {
};

class PollEdit extends React.Component {
  state = {
    id: 'new',
    title: '',
    descr: '',
    date: moment().add(1, 'days').format('DD.MM.YYYY'),
    answers: ['Да', 'Нет', ''],
    showErrors: false,
  }

  componentDidMount() {
    const { actions, params: { pollId } } = this.props;
    if (pollId !== 'new') {
      actions.beginEditPoll(pollId);
    }
  }

  // $FlowFixMe
  UNSAFE_componentWillReceiveProps(nextProps) {
    const wasLoading = this.props.poll.loading;
    const { pollId } = nextProps.params;
    const { loading, id, title, descr, endsAt, choices } = nextProps.poll;
    if ((pollId !== 'new') && (wasLoading !== loading) && (loading === false)) {
      this.setState({
        id,
        title,
        descr,
        date: moment(endsAt).format('DD.MM.YYYY'),
        answers: choices ? choices.map(item => item.title) : [...this.state.answers],
        showErrors: false,
      });
    }
  }

  componentWillUnmount() {
    const { actions, params: { pollId }, poll: { isEdit } } = this.props;
    if (isEdit) {
      actions.stopEditPoll(pollId);
    }
  }

  handleChangeAnswer = (i, e) => {
    const { answers } = this.state;
    const newAnswers = [...answers];
    newAnswers[i] = e.target.value;
    this.setState({ answers: newAnswers });
  }

  handleChangeField = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleChangeDate = (date) => {
    this.setState({ date });
  }

  handleDateBlur = (e) => {
    const date = moment(e.target.value, 'DD.MM.YYYY', true);
    this.setState({
      date: this.isDateValid(date) ? date.format('DD.MM.YYYY') : moment().add(1, 'days').format('DD.MM.YYYY'),
    });
  }

  handleDisabledDaysInDatePicker = day => moment(day).isSameOrBefore(moment(), 'day')

  handleAddAnswer = (e) => {
    e.preventDefault();
    const { answers } = this.state;
    const newAnswers = [...answers, ''];
    this.setState({ answers: newAnswers });
  }

  handleDeleteAnswer = (i, e) => {
    e.preventDefault();
    const { answers } = this.state;
    const newAnswers = answers.filter((el, ix) => !(i === ix));
    this.setState({ answers: newAnswers });
  }

  handleSendPoll = (e) => {
    e.preventDefault();
    const { actions } = this.props;
    const { title, descr, date, answers } = this.state;
    const { schoolId, pollId } = this.props.params;


    if (this.isFormValid()) {
      if (pollId !== 'new') {
        actions.updatePoll({
          poll_id: this.state.id,
          title,
          description: descr,
          ends_at: moment(date, 'DD.MM.YYYY').format(),
          active: true,
          choices: answers,
        }, this.handleSuccessUpdate);
      } else {
        actions.sendNewPoll({
          title,
          description: descr,
          ends_at: moment(date, 'DD.MM.YYYY').format(),
          choices: answers,
          cost: 16.35,
          school_id: schoolId,
        }, this.handleSuccess);
      }
    } else {
      this.setState({ showErrors: true });
    }
  }

  handleSuccess = (id) => {
    const { location: { pathname } } = this.props;
    let url = pathname.split('/').slice(0, 5);
    url = url.join('/');
    this.props.actions.popup('Ваш опрос успешно создан');
    browserHistory.push(`${url}/${id}`);
  }

  handleSuccessUpdate = () => {
    this.props.actions.popup('Ваш опрос успешно обновлен');
    browserHistory.goBack();
  }

  handleCancel = (e) => {
    e.preventDefault();
    browserHistory.goBack();
  }

  handleReload = (e) => {
    e.preventDefault();
    const { actions, params: { pollId } } = this.props;
    actions.beginEditPoll(pollId);
  }

  isDateValid = momentDate => momentDate.isSameOrAfter(moment().startOf('day').add(1, 'days'))

  isFormValid = () => {
    const { title, descr, date, answers } = this.state;
    if (title && descr && this.isDateValid(moment(date, 'DD.MM.YYYY', true)) && !answers.includes('')) {
      return true;
    }
    return false;
  }

  buttonMakeNewText = isLoading => (
    isLoading ? 'Опрос создается...' : 'Создать опрос'
  )

  render = () => {
    const { title, descr, date, answers, showErrors } = this.state;
    const { polls: { isSending }, poll: { loading, isEdit }, params: { pollId } } = this.props;
    const answersItems = answers.map((item, i) =>
      <div className={styles.ansRow} key={i}>
        <div className={styles.num}>{i + 1}.</div>
        <PlainInput
          id={`ans${i + 1}`}
          style={{ width: '80%' }}
          value={item}
          onChange={e => this.handleChangeAnswer(i, e)}
          isError={!item && showErrors}
          errorText={config.errors.emptyField}
        />
        { i > 1
          && <div className={styles.remove}>
            <a href="" onClick={e => this.handleDeleteAnswer(i, e)}>&times;</a>
          </div>
        }
      </div>
    );
    return (
      <div className={styles.root}>
        <div className={styles.formHead}>
          {pollId === 'new' ? 'Создание опроса' : 'Редактирование опроса'}
        </div>

        <div className={styles.form}>
          <div className={styles.formCol1}>
            <div className={styles.h2}>1. Информация</div>
            <PlainInput
              label="Введите заголовок нового опроса"
              id="title"
              value={title}
              onChange={this.handleChangeField}
              isError={!title && showErrors}
              errorText={config.errors.emptyField}
            />
            <PlainTextArea
              label="Описание опроса"
              id="descr"
              value={descr}
              onChange={this.handleChangeField}
              isError={!descr && showErrors}
              errorText={config.errors.emptyField}
              noresize
            />
            <PlainDateInput
              label="Дата окончания"
              id="date"
              style={{ width: '130px' }}
              value={date}
              onChangeDate={this.handleChangeDate}
              onBlur={this.handleDateBlur}
              disabledDaysInPicker={this.handleDisabledDaysInDatePicker}
            />
          </div>
          <div className={styles.formCol2}>
            <div className={styles.h2}>2. Ответы</div>
            <div className={styles.h3}>Введите варианты ответов</div>
            { answersItems }
            { answers.length < 5
              && <a
                onClick={this.handleAddAnswer}
                href=""
                className={styles.add}
              >
              Добавить строку
              </a> }
          </div>
        </div>

        <div className={styles.buttons}>
          <Button outline class={styles.bt} href="" onClick={this.handleCancel}>Отмена</Button>
          <Button
            onClick={this.handleSendPoll}
            disabled={isSending}
          >
            {pollId === 'new'
              ? this.buttonMakeNewText(isSending)
              : 'Сохранить опрос'}
          </Button>
        </div>

        {loading
          && <div className={styles.loading}>
            <IconLoaderClock className={styles.clock} />
          </div>
        }

        {!loading && !isEdit && (pollId !== 'new')
          && <div className={styles.err}>
            <div>Не удалось заблокировать опрос для редактирования</div>
            <Button onClick={this.handleReload}>Повторить</Button>
          </div>
        }

      </div>
    );
  }
}

// PollEdit.propTypes = propTypes;
PollEdit.defaultProps = defaultProps;

const mapStateToProps = store => ({
  polls: store.fund.polls,
  poll: store.fund.poll,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    sendNewPoll: (obj, cb) => dispatch(sendNewPoll(obj, cb)),
    updatePoll: (obj, cb) => dispatch(updatePoll(obj, cb)),
    beginEditPoll: id => dispatch(beginEditPoll(id)),
    stopEditPoll: id => dispatch(stopEditPoll(id)),
    popup: text => dispatch(popup(text)),
  },
});


export default connect(mapStateToProps, mapDispatchToProps)(PollEdit);
